# Real Use Cases for Our Work

## Privacy-Sensitive Personal Automation

Email triage and inbox management without exposing messages to cloud services

Smart home rule generation for Home Assistant using natural language

Document processing for receipts, medical records, and family photos

## Development Workflows

Code review and refactoring for proprietary codebases

Generate test cases and documentation without API costs

Explore unfamiliar legacy systems and new frameworks

## Homelab & Self-Hosting

Network activity reports from firewall logs in plain English

Media library organization and personalized recommendations

Server alert translation into actionable, prioritized notifications